module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return (function () { return _vm.isManagedInventoryCustomer ? _vm.onSubmitManagedService() : _vm.onSubmitFlooring(); })($event)
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("name")))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0px 0px",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "display": "flex",
      "padding-right": "10px",
      "flex-direction": "column",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px 10px 0px 0px"
    }
  }, [_c('h5', [_vm._v("Publisher")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      "value": _vm.pubName
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "display": "flex",
      "padding-left": "10px",
      "flex-direction": "column",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px 0px 0px 10px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Is the customer a Floors/Analytics customer or are we managing their inventory?"
    }
  }, [_vm._v("Site Type")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Managed Inventory or Flooring"
    },
    model: {
      value: (_vm.site_type),
      callback: function($$v) {
        _vm.site_type = $$v
      },
      expression: "site_type"
    }
  }, _vm._l((_vm.siteTypeList), function(type) {
    return _c('el-option', {
      key: type.id,
      attrs: {
        "label": ("" + (type.label)),
        "value": type.value
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-weight": "bold",
      "padding": "0px 0px 0px 0px"
    }
  }, [_vm._v("Site")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0px 0px",
      "display": "flex",
      "gap": "20px",
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex",
      "gap": "20px",
      "width": "100%"
    }
  }, [(_vm.isManagedInventoryCustomer) ? _c('div', {
    staticClass: "col-sm-3",
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "padding": "0px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Is the site an SPA? If unsure, please contact the tech team"
    }
  }, [_vm._v("Single Page Application")]), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    on: {
      "change": _vm.toggleIsSiteSPA
    },
    model: {
      value: (_vm.isSiteSPA),
      callback: function($$v) {
        _vm.isSiteSPA = $$v
      },
      expression: "isSiteSPA"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "padding": "0px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Is the site an SPA? If unsure, please contact the tech team"
    }
  }, [_vm._v("Safety Bypass")]), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.hasSafetyByPass),
      callback: function($$v) {
        _vm.hasSafetyByPass = $$v
      },
      expression: "hasSafetyByPass"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "padding": "0px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Should ads be rendered without Google Ad Manager?"
    }
  }, [_vm._v("Render Without GAM")]), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.renderWithoutGam),
      callback: function($$v) {
        _vm.renderWithoutGam = $$v
      },
      expression: "renderWithoutGam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "padding": "0px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Should we use the iframe method to detect ad spots?"
    }
  }, [_vm._v("AXT Adspot Determination Method")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "flex": "1",
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select a Detection Method"
    },
    model: {
      value: (_vm.AXT_ADSPOT_DETERMINATION_METHOD),
      callback: function($$v) {
        _vm.AXT_ADSPOT_DETERMINATION_METHOD = $$v
      },
      expression: "AXT_ADSPOT_DETERMINATION_METHOD"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "iframe",
      "label": "Iframe"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "default",
      "label": "Default"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "padding": "0px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Should Mile's prebid analytics adapter be enabled on the site?"
    }
  }, [_vm._v("Analytics")]), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.analytics_enabled),
      callback: function($$v) {
        _vm.analytics_enabled = $$v
      },
      expression: "analytics_enabled"
    }
  })], 1), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', {
    staticClass: "col-sm-3",
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "padding": "0px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Are we expected to load the Amazon Publisher Services tag on the client's site?"
    }
  }, [_vm._v("Load APS Tag")]), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.shouldLoadAPSTag),
      callback: function($$v) {
        _vm.shouldLoadAPSTag = $$v
      },
      expression: "shouldLoadAPSTag"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex",
      "gap": "20px",
      "row-gap": "20px",
      "align-items": "end",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Do we use regular Div IDs to identify and target ad spots on the site? Or do we use CSS3 query selectors to identify and target ad spots? If unsure, please contact the tech team"
    }
  }, [_vm._v("Selector Used in Layouts")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "flex": "1",
      "width": "100%"
    },
    attrs: {
      "placeholder": "Selectors"
    },
    model: {
      value: (_vm.selectorUsed),
      callback: function($$v) {
        _vm.selectorUsed = $$v
      },
      expression: "selectorUsed"
    }
  }, _vm._l((_vm.selectorUsedList), function(selector) {
    return _c('el-option', {
      key: selector.id,
      attrs: {
        "label": ("" + (selector.label)),
        "value": selector.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    class: [_vm.isSiteSPA ? 'container-disabled' : ''],
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Is there a delay from page load to the insertion of first impression ad spots on the client's site? If yes, please add a delay so that we intentionally delay the detection of the first impression. If unsure, contact the tech team"
    }
  }, [_vm._v("Delay First Impression Detection")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.shouldDelayFIDetection),
      callback: function($$v) {
        _vm.shouldDelayFIDetection = $$v
      },
      expression: "shouldDelayFIDetection"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    class: [!_vm.shouldDelayFIDetection && !_vm.isSiteSPA ? 'container-disabled' : ''],
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px",
      "flex-direction": "column"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "How long should the maximum delay be while waiting to detect ad spots for the first impression?"
    }
  }, [_vm._v("Delay")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "flex": "1",
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select the duration of delay"
    },
    model: {
      value: (_vm.fiDetectionDelaySpeed),
      callback: function($$v) {
        _vm.fiDetectionDelaySpeed = $$v
      },
      expression: "fiDetectionDelaySpeed"
    }
  }, _vm._l((_vm.detectionSpeedList), function(speed) {
    return _c('el-option', {
      key: speed.id,
      attrs: {
        "label": ("" + (speed.label)),
        "value": speed.value
      }
    })
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex",
      "gap": "20px",
      "width": "100%"
    }
  }, [(_vm.isManagedInventoryCustomer) ? _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Should we remove schain from bid requests originating from the client? If unsure, please contact the tech team"
    }
  }, [_vm._v("Remove Supply Chain for Client Side Bidders?")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.isRemoveSChainEnabled),
      callback: function($$v) {
        _vm.isRemoveSChainEnabled = $$v
      },
      expression: "isRemoveSChainEnabled"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px"
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-weight": "bold",
      "padding": "0px 0px 0px 0px"
    }
  }, [_vm._v("Floors")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "gap": "20px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Should Mile floors be enabled on the client's site?"
    }
  }, [_vm._v("Enabled")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    on: {
      "change": _vm.toggleFloors
    },
    model: {
      value: (_vm.isFloorsEnabled),
      callback: function($$v) {
        _vm.isFloorsEnabled = $$v
      },
      expression: "isFloorsEnabled"
    }
  })], 1), _vm._v(" "), (_vm.isFloorsEnabled) ? _c('div', {
    staticClass: "col-md-4",
    class: [!_vm.isFloorsEnabled ? 'container-disabled' : ''],
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Should we push the rejected bid with the highest CPM from the rejected bids, forcefully, while sending the GAM request for the slot thereby inducing greater competition for the final auction in the ad server?"
    }
  }, [_vm._v("Push through rejected bids")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.isPushThroughBidEnabled),
      callback: function($$v) {
        _vm.isPushThroughBidEnabled = $$v
      },
      expression: "isPushThroughBidEnabled"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isFloorsEnabled) ? _c('div', {
    staticClass: "col-md-4",
    class: [!_vm.isFloorsEnabled ? 'container-disabled' : ''],
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Should we enable floors only based on an external signal, like a flag being present on the client's site?"
    }
  }, [_vm._v("Externally signalled floors")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.externallySignalledFloors),
      callback: function($$v) {
        _vm.externallySignalledFloors = $$v
      },
      expression: "externallySignalledFloors"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isFloorsEnabled) ? _c('div', {
    staticClass: "col-md-4",
    class: [!_vm.isFloorsEnabled ? 'container-disabled' : ''],
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Should floors be split based on session?"
    }
  }, [_vm._v("Session based split enabled")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.isFloorsSessionBasedSplitEnabled),
      callback: function($$v) {
        _vm.isFloorsSessionBasedSplitEnabled = $$v
      },
      expression: "isFloorsSessionBasedSplitEnabled"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.isFloorsEnabled) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row third-party-container",
    class: [!_vm.isFloorsEnabled ? 'container-disabled' : ''],
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 title-container with-form",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_vm._m(1), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    on: {
      "change": _vm.toggleSoftFloors
    },
    model: {
      value: (_vm.isSoftFloorsEnabled),
      callback: function($$v) {
        _vm.isSoftFloorsEnabled = $$v
      },
      expression: "isSoftFloorsEnabled"
    }
  })], 1)]), _vm._v(" "), (_vm.isFloorsEnabled && _vm.isSoftFloorsEnabled) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_vm._l((_vm.softFloorConfig), function(config) {
    return _c('div', {
      key: config.name,
      staticClass: "row col-sm-12 soft-floor-browser",
      staticStyle: {
        "display": "flex",
        "gap": "0px",
        "align-items": "end",
        "justify-content": "space-evenly",
        "padding": "0px",
        "margin": "0px !important"
      }
    }, [_c('div', {
      staticClass: "col-sm-6",
      staticStyle: {
        "display": "flex",
        "flex-direction": "column",
        "align-items": "baseline",
        "justify-content": "space-between",
        "padding": "0px 10px 0px 0px"
      }
    }, [_c('h5', [_vm._v("Browser")]), _vm._v(" "), _c('el-input', {
      staticClass: "soft-floor-browser capitalize",
      staticStyle: {
        "width": "100%",
        "pointer-events": "none"
      },
      attrs: {
        "value": config.name
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6",
      staticStyle: {
        "display": "flex",
        "flex-direction": "column",
        "align-items": "baseline",
        "justify-content": "space-between",
        "padding": "0px 10px 0px 10px"
      }
    }, [_c('h5', {
      staticStyle: {
        "cursor": "help"
      },
      attrs: {
        "title": "Method used to detect the layout on each page of the site"
      }
    }, [_vm._v("Percentage of Traffic Applied to")]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "100%",
        "pointer-events": "none"
      },
      attrs: {
        "value": config.percentage
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "add-button",
      staticStyle: {
        "padding": "0px 0px 0px 10px"
      }
    }, [_c('button', {
      staticClass: "el-button only-icon danger",
      staticStyle: {
        "height": "40px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function () { return _vm.deleteSoftFloorConfig(config); }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete el-icon-left"
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row col-sm-12 add-soft-floor",
    staticStyle: {
      "display": "flex",
      "gap": "15px",
      "align-items": "end",
      "justify-content": "space-evenly",
      "padding": "0px 15px 15px 15px",
      "margin": "20px 0px 0px 0px !important",
      "background": "#F9F7FF",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Browser soft floors is applied to"
    }
  }, [_vm._v("Browser")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Select a Browser"
    },
    model: {
      value: (_vm.softFloorBrowserToAdd),
      callback: function($$v) {
        _vm.softFloorBrowserToAdd = $$v
      },
      expression: "softFloorBrowserToAdd"
    }
  }, _vm._l((_vm.softFloorsBrowserList), function(browser) {
    return _c('el-option', {
      key: browser.id,
      attrs: {
        "label": browser.label,
        "value": browser.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Percentage of traffic soft floors is applied to"
    }
  }, [_vm._v("Percentage of traffic Soft floors is applied to")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%",
      "background": "none !important"
    },
    model: {
      value: (_vm.softFloorPercentageToAdd),
      callback: function($$v) {
        _vm.softFloorPercentageToAdd = $$v
      },
      expression: "softFloorPercentageToAdd"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "add-button"
  }, [_c('button', {
    staticClass: "el-button only-icon",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addSoftFloor
    }
  }, [_c('i', {
    staticClass: "el-icon-plus el-icon-left"
  })])])])], 2) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('hr'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-weight": "bold",
      "padding": "0px 0px 0px 0px"
    }
  }, [_vm._v("Prebid.js")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0px 0px",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex",
      "gap": "20px",
      "width": "100%"
    }
  }, [(_vm.isManagedInventoryCustomer) ? _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "padding": "0px",
      "display": "flex",
      "flex-direction": "column",
      "align-items": "baseline",
      "justify-content": "space-between"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Version of prebid maintained by us on the client's site"
    }
  }, [_vm._v("Prebid Version")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "flex": "1",
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Select a Prebid Version"
    },
    model: {
      value: (_vm.selectedPrebidVersion),
      callback: function($$v) {
        _vm.selectedPrebidVersion = $$v
      },
      expression: "selectedPrebidVersion"
    }
  }, _vm._l((_vm.prebidVersionsList), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "padding": "0px",
      "display": "flex",
      "flex-direction": "column",
      "align-items": "baseline",
      "justify-content": "space-between"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Default timeout for Prebid.js auctions configured on the client's site"
    }
  }, [_vm._v("Global Auction Timeout (ms)")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "value": _vm.auctionTimeout
    },
    model: {
      value: (_vm.auctionTimeout),
      callback: function($$v) {
        _vm.auctionTimeout = $$v
      },
      expression: "auctionTimeout"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isManagedInventoryCustomer) ? _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "padding": "0px",
      "display": "flex",
      "flex-direction": "column",
      "align-items": "baseline",
      "justify-content": "space-between"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Variable name of the global prebid object that handles the auctions on the client's site"
    }
  }, [_vm._v("Global Prebid Object Name")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "value": _vm.global_prebid_object
    },
    model: {
      value: (_vm.global_prebid_object),
      callback: function($$v) {
        _vm.global_prebid_object = $$v
      },
      expression: "global_prebid_object"
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', [_c('hr'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-weight": "bold",
      "padding": "0px 0px 20px 0px"
    }
  }, [_vm._v("Google Ad Manager")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "row third-party-container"
  }, [_c('div', {
    staticClass: "col-sm-12 title-container with-form",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_vm._m(2), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    on: {
      "change": _vm.resetMCM
    },
    model: {
      value: (_vm.mcm_enabled),
      callback: function($$v) {
        _vm.mcm_enabled = $$v
      },
      expression: "mcm_enabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    class: !_vm.mcm_enabled ? "container-disabled" : "",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "gap": "20px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex",
      "gap": "20px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px",
      "flex-direction": "column"
    }
  }, [_c('h5', {
    staticStyle: {
      "cursor": "help"
    },
    attrs: {
      "title": "Method used to detect the layout on each page of the site"
    }
  }, [_vm._v("Parent DFP Network")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "flex": "1",
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.mcm_enabled,
      "filterable": "",
      "placeholder": "Select a Parent DFP Network"
    },
    on: {
      "change": _vm.filterNetworkList
    },
    model: {
      value: (_vm.dfp_network),
      callback: function($$v) {
        _vm.dfp_network = $$v
      },
      expression: "dfp_network"
    }
  }, _vm._l((_vm.getDfpNetworks(_vm.dfp_credentials)), function(network) {
    return _c('el-option', {
      key: network.id,
      attrs: {
        "label": ("" + (network.network_code +' : ' + network.display_name)),
        "value": network.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px",
      "flex-direction": "column"
    }
  }, [_c('h5', [_vm._v("MCM Delegation Type")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "flex": "1",
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select MCM Delegation Type",
      "disabled": !_vm.mcm_enabled
    },
    on: {
      "change": _vm.filterNetworkList
    },
    model: {
      value: (_vm.account_type),
      callback: function($$v) {
        _vm.account_type = $$v
      },
      expression: "account_type"
    }
  }, _vm._l((_vm.mcmAccountType), function(mcm_account_type, id) {
    return _c('el-option', {
      key: id,
      attrs: {
        "data-id": id,
        "label": {
          'MANAGE_INVENTORY': 'Manage Inventory',
          'MANAGE_ACCOUNT': 'Manage Account'
        } [mcm_account_type.account_type],
        "value": mcm_account_type.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px",
      "flex-direction": "column"
    }
  }, [_c('h5', {
    staticStyle: {
      "cursor": "help"
    },
    attrs: {
      "title": "Method used to detect the layout on each page of the site"
    }
  }, [_vm._v("Child DFP Network")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "flex": "1",
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.mcm_enabled,
      "filterable": "",
      "placeholder": "Select Child DFP Network"
    },
    model: {
      value: (_vm.child_dfp_network),
      callback: function($$v) {
        _vm.child_dfp_network = $$v
      },
      expression: "child_dfp_network"
    }
  }, _vm._l((_vm.filteredAccountList), function(network) {
    return _c('el-option', {
      key: network.id,
      attrs: {
        "label": ("" + (network.child_network_code +' : ' + network.name)),
        "value": network.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row third-party-container",
    class: _vm.mcm_enabled ? "container-disabled" : ""
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "gap": "20px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex",
      "gap": "0px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px"
    }
  }, [_c('h5', [_vm._v("Parent DFP Network")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Select",
      "disabled": _vm.mcm_enabled
    },
    model: {
      value: (_vm.pubdetailistid),
      callback: function($$v) {
        _vm.pubdetailistid = $$v
      },
      expression: "pubdetailistid"
    }
  }, _vm._l((_vm.dfpNetworkListAsPerSelectedDfpAccount), function(dfp) {
    return _c('el-option', {
      key: dfp.id,
      attrs: {
        "label": ((dfp.network_code) + " : " + (dfp.display_name)),
        "value": dfp.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row third-party-container"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "gap": "20px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex",
      "gap": "0px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px"
    }
  }, [_c('h5', [_vm._v("Parent Ad Unit ID")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Parent Ad Unit ID"
    },
    model: {
      value: (_vm.parent_ad_unit_id),
      callback: function($$v) {
        _vm.parent_ad_unit_id = $$v
      },
      expression: "parent_ad_unit_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px",
      "padding-left": "20px"
    }
  }, [_c('h5', [_vm._v("Parent Ad Unit Code")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Parent Ad Unit Code"
    },
    model: {
      value: (_vm.parent_ad_unit_code),
      callback: function($$v) {
        _vm.parent_ad_unit_code = $$v
      },
      expression: "parent_ad_unit_code"
    }
  })], 1)])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row third-party-container container-disabled"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "gap": "20px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex",
      "gap": "20px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px"
    }
  }, [_c('h5', [_vm._v("Parent Ad Unit ID")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "AMP Parent Ad Unit ID"
    },
    model: {
      value: (_vm.amp_parent_ad_unit_id),
      callback: function($$v) {
        _vm.amp_parent_ad_unit_id = $$v
      },
      expression: "amp_parent_ad_unit_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px"
    }
  }, [_c('h5', [_vm._v("Parent Ad Unit Code")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "AMP Parent Ad Unit Code"
    },
    model: {
      value: (_vm.amp_parent_ad_unit_code),
      callback: function($$v) {
        _vm.amp_parent_ad_unit_code = $$v
      },
      expression: "amp_parent_ad_unit_code"
    }
  })], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', [_c('hr'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-weight": "bold",
      "padding": "0px 0px 0px 0px"
    }
  }, [_vm._v("Privacy")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "gap": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "gap": "20px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Should we add GDPR consent check for Prebid.js on the client's site?"
    }
  }, [_vm._v("GDPR")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.gdprConsentRequired),
      callback: function($$v) {
        _vm.gdprConsentRequired = $$v
      },
      expression: "gdprConsentRequired"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "display": "flex",
      "align-items": "baseline",
      "justify-content": "space-between",
      "padding": "0px"
    }
  }, [_c('h5', {
    staticClass: "field-label",
    attrs: {
      "title": "Should we add CCPA consent check for Prebid.js on the client's site?"
    }
  }, [_vm._v("CCPA")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.ccpaConsentRequired),
      callback: function($$v) {
        _vm.ccpaConsentRequired = $$v
      },
      expression: "ccpaConsentRequired"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-weight": "bold",
      "padding": "0px 0px 20px 0px"
    }
  }, [_vm._v("Third Party Vendors")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "row third-party-container"
  }, [_c('div', {
    staticClass: "col-md-12 mt-3 title-container with-form",
    class: [_vm.isWKNDEnabled ? '' : 'not-enabled']
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("WunderKind — Interstitial ")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.isWKNDEnabled),
      callback: function($$v) {
        _vm.isWKNDEnabled = $$v
      },
      expression: "isWKNDEnabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 my-3",
    class: [_vm.isWKNDEnabled ? '' : 'notIsEnabled']
  }, [_c('div', {
    staticClass: "col-md-12 3pv-row p-0"
  }, [_c('h5', [_vm._v("Site ID")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Wunderkind Site ID"
    },
    model: {
      value: (_vm.wkndSiteID),
      callback: function($$v) {
        _vm.wkndSiteID = $$v
      },
      expression: "wkndSiteID"
    }
  })], 1)])]), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row third-party-container"
  }, [_c('div', {
    staticClass: "col-md-12 mt-3 title-container with-form",
    class: [_vm.isIIQEnabled ? '' : 'not-enabled']
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_vm._m(6), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.isIIQEnabled),
      callback: function($$v) {
        _vm.isIIQEnabled = $$v
      },
      expression: "isIIQEnabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 my-3",
    class: [_vm.isIIQEnabled ? '' : 'notIsEnabled']
  }, [_c('div', {
    staticClass: "col-md-4 3pv-row p-0"
  }, [_c('h5', [_vm._v("Partner ID")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Intent IIQ Partner ID"
    },
    model: {
      value: (_vm.iiqPartnerID),
      callback: function($$v) {
        _vm.iiqPartnerID = $$v
      },
      expression: "iiqPartnerID"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row third-party-container"
  }, [_c('div', {
    staticClass: "col-md-12 mt-3 title-container with-form",
    class: [_vm.isLiveIntentEnabled ? '' : 'not-enabled']
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_vm._m(7), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.isLiveIntentEnabled),
      callback: function($$v) {
        _vm.isLiveIntentEnabled = $$v
      },
      expression: "isLiveIntentEnabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 my-3",
    class: [_vm.isLiveIntentEnabled ? '' : 'notIsEnabled']
  }, [_c('div', {
    staticClass: "col-md-4 3pv-row p-0 liPubID"
  }, [_c('h5', [_vm._v("Publisher ID")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Publisher ID"
    },
    model: {
      value: (_vm.liPartnerID),
      callback: function($$v) {
        _vm.liPartnerID = $$v
      },
      expression: "liPartnerID"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 3pv-row p-0 liScriptURL"
  }, [_c('h5', [_vm._v("Script URL (without protocol)")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "URL"
    },
    model: {
      value: (_vm.liScriptURL),
      callback: function($$v) {
        _vm.liScriptURL = $$v
      },
      expression: "liScriptURL"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row third-party-container"
  }, [_c('div', {
    staticClass: "col-md-12 mt-3 title-container with-form",
    class: [_vm.isID5Enabled ? '' : 'not-enabled']
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("ID5 — User ID")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.isID5Enabled),
      callback: function($$v) {
        _vm.isID5Enabled = $$v
      },
      expression: "isID5Enabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 my-3",
    class: [_vm.isID5Enabled ? '' : 'notIsEnabled']
  }, [_c('div', {
    staticClass: "col-md-4 3pv-row p-0"
  }, [_c('h5', [_vm._v("Partner ID")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Partner ID"
    },
    model: {
      value: (_vm.id5PartnerID),
      callback: function($$v) {
        _vm.id5PartnerID = $$v
      },
      expression: "id5PartnerID"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row third-party-container"
  }, [_c('div', {
    staticClass: "col-md-12 mt-3 title-container with-form",
    class: [_vm.isHadronEnabled ? '' : 'not-enabled']
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("Hadron — User ID ")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.isHadronEnabled),
      callback: function($$v) {
        _vm.isHadronEnabled = $$v
      },
      expression: "isHadronEnabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 my-3",
    class: [_vm.isHadronEnabled ? '' : 'notIsEnabled']
  }, [_c('div', {
    staticClass: "col-md-4 3pv-row p-0"
  }, [_c('h5', [_vm._v("Partner ID")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Partner ID"
    },
    model: {
      value: (_vm.hadronPartnerID),
      callback: function($$v) {
        _vm.hadronPartnerID = $$v
      },
      expression: "hadronPartnerID"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row third-party-container"
  }, [_c('div', {
    staticClass: "col-md-12 mt-3 title-container with-form",
    class: [_vm.isLotamIDEnabled ? '' : 'not-enabled']
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("Lotame Pantone — User ID ")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.isLotamIDEnabled),
      callback: function($$v) {
        _vm.isLotamIDEnabled = $$v
      },
      expression: "isLotamIDEnabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 my-3",
    class: [_vm.isLotamIDEnabled ? '' : 'notIsEnabled']
  }, [_c('div', {
    staticClass: "col-md-4 3pv-row p-0"
  }, [_c('h5', [_vm._v("Client ID")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Client ID"
    },
    model: {
      value: (_vm.lotameClientID),
      callback: function($$v) {
        _vm.lotameClientID = $$v
      },
      expression: "lotameClientID"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row third-party-container"
  }, [_c('div', {
    staticClass: "col-md-12 mt-3 title-container with-form",
    class: [_vm.isLexiconEnabled ? '' : 'not-enabled']
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("Lexicon — User ID ")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.isLexiconEnabled),
      callback: function($$v) {
        _vm.isLexiconEnabled = $$v
      },
      expression: "isLexiconEnabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 my-3",
    class: [_vm.isLexiconEnabled ? '' : 'notIsEnabled']
  }, [_c('div', {
    staticClass: "col-md-4 3pv-row p-0"
  }, [_c('h5', [_vm._v("Partner ID")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Client ID"
    },
    model: {
      value: (_vm.lexiconPartnerID),
      callback: function($$v) {
        _vm.lexiconPartnerID = $$v
      },
      expression: "lexiconPartnerID"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row third-party-container"
  }, [_c('div', {
    staticClass: "col-md-12 mt-3 title-container with-form",
    class: [_vm.isTTDUnifiedIDEnabled ? '' : 'not-enabled']
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("TTD - UnifiedID — User ID ")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.isTTDUnifiedIDEnabled),
      callback: function($$v) {
        _vm.isTTDUnifiedIDEnabled = $$v
      },
      expression: "isTTDUnifiedIDEnabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 my-3",
    class: [_vm.isTTDUnifiedIDEnabled ? '' : 'notIsEnabled']
  }, [_c('div', {
    staticClass: "col-md-4 3pv-row p-0"
  }, [_c('h5', [_vm._v("Cookie Partner ID")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Cookie Partner ID"
    },
    model: {
      value: (_vm.ttdCookiePartnerID),
      callback: function($$v) {
        _vm.ttdCookiePartnerID = $$v
      },
      expression: "ttdCookiePartnerID"
    }
  })], 1)])])]), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row third-party-container"
  }, [_c('div', {
    staticClass: "col-md-12 mt-3 title-container with-form",
    class: [_vm.isUID2Enabled ? '' : 'not-enabled']
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("UID2 — User ID ")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.isUID2Enabled),
      callback: function($$v) {
        _vm.isUID2Enabled = $$v
      },
      expression: "isUID2Enabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 my-3",
    class: [_vm.isUID2Enabled ? '' : 'notIsEnabled']
  }, [_c('div', {
    staticClass: "col-md-4 3pv-row p-0"
  }, [_c('h5', [_vm._v("UID2 ID Cookie Name")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "UID2Cookie "
    },
    model: {
      value: (_vm.uid2ServerCookie),
      callback: function($$v) {
        _vm.uid2ServerCookie = $$v
      },
      expression: "uid2ServerCookie"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row third-party-container"
  }, [_c('div', {
    staticClass: "col-md-12 mt-3 title-container"
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("Criteo ID — User ID ")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.isCriteoIDEnabled),
      callback: function($$v) {
        _vm.isCriteoIDEnabled = $$v
      },
      expression: "isCriteoIDEnabled"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row third-party-container"
  }, [_c('div', {
    staticClass: "col-md-12 mt-3 title-container"
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("Shared ID — User ID ")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.isSharedIDEnabled),
      callback: function($$v) {
        _vm.isSharedIDEnabled = $$v
      },
      expression: "isSharedIDEnabled"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row third-party-container"
  }, [_c('div', {
    staticClass: "col-md-12 mt-3 title-container"
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("Amx ID — User ID ")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.isAmxIDEnabled),
      callback: function($$v) {
        _vm.isAmxIDEnabled = $$v
      },
      expression: "isAmxIDEnabled"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isManagedInventoryCustomer) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row third-party-container"
  }, [_c('div', {
    staticClass: "col-md-12 mt-3 title-container"
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("Kueez RTB — Performance Enhancing Script")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#765CDF",
      "inactive-color": "#CDCFD0"
    },
    model: {
      value: (_vm.isKueezPECEnabled),
      callback: function($$v) {
        _vm.isKueezPECEnabled = $$v
      },
      expression: "isKueezPECEnabled"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix cta-button-container"
  }, [(_vm.isManagedInventoryCustomer) ? _c('button', {
    staticClass: "el-button el-button migrate-domain",
    staticStyle: {
      "display": "flex",
      "gap": "10px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.account_type === null && _vm.child_dfp_network === null
    },
    on: {
      "click": _vm.migrateToMCM
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon-left"
  }), _vm._v("\n              Migrate Domain\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button update",
    staticStyle: {
      "display": "flex",
      "gap": "10px"
    },
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    class: _vm.updatingDomain ? 'el-icon-loading' : 'el-icon-edit'
  }), _vm._v("\n              " + _vm._s(_vm.updatingDomain ? 'Updating Domain ...' : 'Update Domain') + "\n            ")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Edit Domain")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-with-info-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("Soft Floors")]), _vm._v(" "), _c('div', {
    staticClass: "info-container",
    attrs: {
      "title": "Should Mile floors not be enforced strictly on the client's site?"
    }
  }, [_c('span', {
    staticClass: "fa-info"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-with-info-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("MCM")]), _vm._v(" "), _c('div', {
    staticClass: "info-container",
    attrs: {
      "title": ""
    }
  }, [_c('span', {
    staticClass: "fa-info"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 title-container with-form",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_c('div', {
    staticClass: "header-with-info-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("DFP Network")]), _vm._v(" "), _c('div', {
    staticClass: "info-container",
    attrs: {
      "title": ""
    }
  }, [_c('span', {
    staticClass: "fa-info"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 title-container with-form",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_c('div', {
    staticClass: "header-with-info-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("Display")]), _vm._v(" "), _c('div', {
    staticClass: "info-container",
    attrs: {
      "title": ""
    }
  }, [_c('span', {
    staticClass: "fa-info"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 title-container with-form",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "enable-3pv-container"
  }, [_c('div', {
    staticClass: "header-with-info-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("AMP")]), _vm._v(" "), _c('div', {
    staticClass: "info-container",
    attrs: {
      "title": ""
    }
  }, [_c('span', {
    staticClass: "fa-info"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-with-info-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("Intent IQ — User ID ")]), _vm._v(" "), _c('div', {
    staticClass: "info-container",
    attrs: {
      "title": "Intent IIQ is a User ID Vendor. Once enabled, it is only activated on Safari and Firefox browsers in the US and Canada"
    }
  }, [_c('span', {
    staticClass: "fa-info"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-with-info-container"
  }, [_c('h4', {
    staticClass: "section-header"
  }, [_vm._v("Live Intent — User ID")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a6ec39d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/EditDomain.vue
// module id = 718
// module chunks = 2